import { CheckBoxList } from '../../../base';
import { useLookupRoles } from '../useLookupRoles';

type ICheckedBoxListRoleProps = {
	name: string;
	selectedValue: any[];
	onSelectionChanged: (values: any[]) => void;
	label?: string;
	labelSmall?: boolean;
	hasValid?: boolean;
	error?: string;
	sizeClass?: 'xs' | 'sm' | 'md' | 'lg';
	helpBlock?: string;
};

export const CheckedBoxListRole = (props: ICheckedBoxListRoleProps) => {
	const { name, label, labelSmall, hasValid } = props;
	const { roles_lookup } = useLookupRoles();
	return (
		<>
			<div className='space-y-2'>
				{label && (
					<div>
						<label className={`text-sm font-medium text-foreground ${labelSmall ? 'text-xs' : ''}`} htmlFor={name}>
							{label} {hasValid && <em className='text-danger'>(*)</em>}
						</label>
					</div>
				)}
				<div className='w-full'>
					<CheckBoxList dataSource={roles_lookup} displaySubExpr='description' displayExpr='name' keyExpr='id' {...props} />
				</div>
			</div>
		</>
	);
};